import { fetch } from '@/utils/http'

export default {
  getBlockChainList: params => fetch('get', '/cbaas-service/v1/cert/queryRootCert', params),
  queryOrgCertByNodeCid: params =>
    fetch('get', '/cbaas-service/v1/cert/queryOrgCertByNodeCid', params),
  createChain: params => fetch('post', '/cbaas-service/v1/chainManagement/createChain', params),
  downLoadPackage: params =>
    fetch('get', '/cbaas-service/v1/chainManagement/downloadChain', params),
  getOrgByAlgo: params => fetch('get', '/cbaas-service/v1/cert/getCertOrgList', params),
  getNodeByOrg: params => fetch('get', '/cbaas-service/v1/cert/getCertNodeList', params),
  subscribeChain: params =>
    fetch('post', '/cbaas-service/v1/chainManagement/subScribeChain', params), // 订阅区块链
  revokeChain: params => 
    fetch('put', `/cbaas-service/v1/chainManagement/unsubscribeChain?ChainId=${params.ChainId}`, params), // 取消订阅
  deleteChain: params =>
    fetch('delete', `/v1/chainManagement/deleteChain?ChainId=${params.ChainId}`, params), // 删除区块链
  //概览
  chainAuthManage: params =>
    fetch('get', '/cbaas-service/v1/chainManagement/queryContractAuthList', params),
  modifySetting: params =>
    fetch('post', '/cbaas-service/v1/chainManagement/modifyChainConfig', params),
  //合约管理
  getBlockContractList: params => fetch('get', '/cbaas-service/v1/contract/list', params),
  installContract: params => fetch('post', '/cbaas-service/v1/contract/install', params), //部署
  getRuntimeTypeList: params => fetch('get', '/cbaas-service/v1/contract/runtimeTypeList', params),
  uploadContract: params => fetch('post', '/cbaas-service/v1/upload/file', params),

  freezeContract: params => fetch('post', '/cbaas-service/v1/contract/freeze', params), //冻结
  unfreezeContract: params => fetch('post', '/cbaas-service/v1/contract/unfreeze', params), //解冻
  revokeContract: params => fetch('post', '/cbaas-service/v1/contract/revoke', params), //撤销
  upgradeContract: params => fetch('post', '/cbaas-service/v1/contract/upgrade', params), //升级
  modifyContract: params => fetch('post', '/cbaas-service/v1/contract/modify', params), //编辑
  //上链管理
  getUpperChainList: params =>
    fetch('get', '/cbaas-service/v1/contract/invoke/record/list', params),
  getInvokeList: params => fetch('get', '/cbaas-service/v1/contract/invoke/list', params),
  invokeContract: params => fetch('post', '/cbaas-service/v1/contract/invoke', params),
  getContractDetail: params => fetch('get', '/cbaas-service/v1/contract/detail', params),

  getVoteList: params => fetch('get', '/cbaas-service/v1/vote/queryVoteList', params),
  doVote: params => fetch('post', '/cbaas-service/v1/vote/vote', params),
  getChainOrgList: params =>
    fetch('get', '/cbaas-service/v1/chainManagement/queryChainOrg', params),

  getNodesInfo: params => fetch('post', '/cbaas-service/v1/monitor/queryNodesInfo', params), //获取节点信息

  getChainNodeList: params =>
    fetch('get', '/cbaas-service/v1/chainManagement/queryChainOrgNode', params),
  //获取用户属性列表
  getAttributeList: params => fetch('get', '/cbaas-service/v1/mt/attribute/list', params),

  //新建用户信息
  createUser: params => fetch('post', '/cbaas-service/v1/mt/user/create', params),

  //医疗数据上传加密
  uploadData: params => fetch('post', '/cbaas-service/v1/mt/upload/data', params),

  //医疗数据访问
  searchData: params => fetch('post', '/cbaas-service/v1/mt/search', params),

  //医疗数据访问解密
  searchDecrypt: params => fetch('post', '/cbaas-service/v1/mt/searchDecrypt', params),

  //获取用户数据
  getUserList: params => fetch('get', '/cbaas-service/v1/mt/user/list', params),

  //获取用户数据
  saveForm: params => fetch('post', '/api/save', params),

  //获取扩容节点列表
  getOffchainNodeList: params => fetch('get', '/cbaas-service/v1/offchain/node/list', params),

  //获取节点列表
  queryChainOrgNode: params =>
    fetch('get', '/cbaas-service/v1/chainManagement/queryChainOrgNode', params),

  //创建扩容节点
  createOffChain: params => fetch('post', '/cbaas-service/v1/offchain/createOffChain', params),

  //订阅扩容节点
  subscribeOffChain: params =>
    fetch('post', '/cbaas-service/v1/offchain/subscribeOffChain', params),

  //订阅扩容节点
  offchainExit: params => fetch('post', '/cbaas-service/v1/offchain/node/exit', params),

  //链下扩容合约
  installContractOffchain: params =>
    fetch('post', '/cbaas-service/v1/offchain/installContract', params),

  //获取扩容通道列表
  getOffchainChanList: params => fetch('get', '/cbaas-service/v1/offchain/chan/list', params),

  //创建扩容通道
  createChannel: params => fetch('post', '/cbaas-service/v1/offchain/createChannel', params),
  //下载扩容通道
  downloadOffChain: params => fetch('post', '/cbaas-service/v1/offchain/downloadOffChain', params),

  //交易
  channelTrade: params => fetch('post', '/cbaas-service/v1/offchain/trade', params),
  //交易节点
  getTradeNodeList: params => fetch('get', '/cbaas-service/v1/offchain/trade/node/list', params),

  //加入扩容通道
  joinChannel: params => fetch('post', '/cbaas-service/v1/offchain/joinChannel', params),

  //数据归档相关====================================================================
  //获取大致描述
  getProfile: params => fetch('post', '/cbaas-service/v1/archive/dumpedHeight', params),
  //根据时间归档
  dumpByTime: params => fetch('post', '/cbaas-service/v1/archive/dumpByTime', params),
  //根据高度归档
  dumpByHeight: params => fetch('post', '/cbaas-service/v1/archive/dumpByHeight', params),
  //数据恢复
  restore: params => fetch('post', '/cbaas-service/v1/archive/restore', params),
  //根据高度查询
  queryByHeight: params => fetch('post', '/cbaas-service/v1/archive/queryByHeight', params),
  //根据哈希查询
  queryByHash: params => fetch('post', '/cbaas-service/v1/archive/queryByHash', params),
  //根据txId查询
  queryByTxID: params => fetch('post', '/cbaas-service/v1/archive/queryByTxID', params),
  //查交易
  queryTx: params => fetch('post', '/cbaas-service/v1/archive/queryTx', params),
  //==================================================================================

  //Dpos共识相关====================================================================
  //获取Dpos管理员列表
  queryAdmins: params => fetch('get', '/cbaas-service/v1/chainManagement/queryDposAdminList', params),
  //获取Dpos节点列表
  queryNodes: params => fetch('get', '/cbaas-service/v1/chainManagement/queryDposNodeList', params),
  //获取Dpos节点详情
  queryAdminDetails: params => fetch('get', '/cbaas-service/v1/chainManagement/queryDposAdminDetail', params),
  //获取Dpos管理员详情
  queryNodeDetails: params => fetch('get', '/cbaas-service/v1/chainManagement/queryDposNodeDetail', params)
  //==================================================================================
}
